export const OTHER_LOOKED_AT = "k5ae9bc86adf60b750f149bce"
export const OTHER_BOUGHT = "k5ae9bc7dadf60b750f149b49"
export const LATEST_VISITED = "k5bc5c9b3e051816400761cd9"
export const RECOMMENDED_FOR_YOU = "k5ae9bc66adf60b750f149a3d"
export const POPULAR_PRODUCTS = "k5ae9bc63adf60b750f149a1f"
export const BEST_SELLER_CATEGORY = "k5ae9bc8aadf60b750f149c27"
export const CATEGORY_FILTER = [3833, 3991, 3990, 3100, 5103]

